import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../../config";
import logo from "../../assets/logo.png";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Voices", href: "#voices" },
  { label: "Philosophy", href: "#philosophy" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="main-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#07040D]/70 backdrop-blur-xl border-b border-[#D4AF37]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10 h-16 sm:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img
            src={logo}
            alt="Tarot Guidance by Ishita Dhar"
            width="554"
            height="160"
            decoding="async"
            className="h-8 sm:h-11 md:h-12 w-auto object-contain transition-opacity duration-300 group-hover:opacity-90"
          />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs tracking-[0.22em] uppercase text-[#A89FA8] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href={BRAND.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-book-btn"
          className="flex items-center gap-1.5 sm:gap-2 rounded-full border border-[#D4AF37] text-[#D4AF37] px-3.5 py-1.5 sm:px-5 sm:py-2.5 text-[10px] sm:text-xs tracking-[0.14em] sm:tracking-[0.18em] uppercase hover:bg-[#D4AF37] hover:text-[#07040D] transition-colors duration-300"
        >
          <MessageCircle className="w-3 h-3 sm:w-3.5 sm:h-3.5" strokeWidth={1.6} />
          Book a Reading
        </a>
      </div>
    </motion.nav>
  );
};
